import { Link } from 'react-router-dom';
import useScrollReveal from '@/hooks/useScrollReveal';

const areas = [
  'Arlington, TX (Primary)',
  'Fort Worth, TX',
  'Grand Prairie, TX',
  'Mansfield, TX',
  'Euless, TX',
  'Bedford, TX',
  'Irving, TX',
  'Hurst, TX',
  'North Richland Hills, TX',
  'Duncanville, TX',
];

const ServiceAreas = () => {
  const leftRef = useScrollReveal();
  const rightRef = useScrollReveal();

  return (
    <section className="bg-charcoal py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left — content */}
          <div ref={leftRef} className="reveal">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-gold" />
              <span className="font-inter text-gold text-xs font-semibold tracking-[0.25em] uppercase">
                Where We Serve
              </span>
            </div>
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
              Serving Communities Across DFW
            </h2>
            <p className="font-inter text-base text-white/60 leading-relaxed mb-8">
              Our occupational training and job readiness programs are accessible to participants throughout the Dallas–Fort Worth metroplex. If you are ready to build skills and change your future, we are here to help — wherever you are in the region.
            </p>
            <div className="grid grid-cols-2 gap-3 mb-10">
              {areas.map((area) => (
                <div key={area} className="flex items-center gap-2.5">
                  <i className="ri-map-pin-2-fill text-gold text-sm shrink-0" />
                  <span className="font-inter text-sm text-white/70">{area}</span>
                </div>
              ))}
            </div>
            <Link
              to="/location"
              className="inline-flex items-center gap-2 bg-gold hover:bg-gold-dark text-charcoal font-inter font-bold text-sm px-6 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              View Location Details
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Right — map */}
          <div ref={rightRef} className="reveal-right">
            <div className="w-full h-[440px] rounded-lg overflow-hidden border border-white/10">
              <iframe
                title="OST-C Service Area Map - Arlington TX DFW vocational training"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d107038.13156764076!2d-97.24817845!3d32.71372745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e7d1b6bd80635%3A0x2cfaf5d5ef36e0c0!2sArlington%2C%20TX!5e0!3m2!1sen!2sus!4v1712000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
